// Partner portal French Canadian translations.
// Must match every key in en.ts exactly.

import type { TranslationKeys } from './en';

export const fr: TranslationKeys = {
  common: {
    loading: 'Chargement...',
    saving: 'Enregistrement...',
    saved: 'Enregistre.',
    save: 'Enregistrer',
    cancel: 'Annuler',
    back: 'Retour',
    close: 'Fermer',
    menu: 'Menu',
    signOut: 'Deconnexion',
    error: 'Erreur',
    networkError: 'Erreur reseau. Verifiez votre connexion et reessayez.',
    httpError: 'Erreur serveur ({status}). Reessayez ou contactez partners@ailysagency.ca.',
    contactSupport: 'Contacter partners@ailysagency.ca',
    poweredBy: 'Propulse par AiLys',
    notSet: 'Non defini',
    notOnFile: 'Non au dossier',
    enabled: 'Active',
    disabled: 'Desactive',
    yes: 'Oui',
    no: 'Non',
  },

  nav: {
    brand: 'AiLys Partenaire',
    dashboard: 'Tableau de bord',
    clients: 'Clients',
    commissions: 'Commissions',
    team: 'Equipe',
    training: 'Formation',
    whiteLabel: 'Marque blanche',
    settings: 'Parametres',
    profile: 'Profil',
  },

  login: {
    pageTitle: 'Connexion - AiLys Portail partenaire',
    brand: 'AiLys Portail partenaire',
    heading: 'Connexion.',
    subtitle: 'Utilisez les identifiants qu\'AiLys vous a envoyes lors de votre activation en tant que pilote Niveau 1. L\'authentification a deux facteurs est obligatoire; ayez votre application d\'authentification prete.',
    ssoButton: 'Continuer avec l\'authentification unique',
    newPartner: 'Nouvelle agence partenaire?',
    applyLink: 'Postuler via la liste d\'attente du programme partenaire',
    lostAccess: 'Acces perdu?',
    lostAccessEmail: 'partners@ailysagency.ca',
  },

  dashboard: {
    wrongPortalTitle: 'Mauvais portail',
    wrongPortalMsg: 'Vous etes connecte en tant que client. Le portail partenaire a',
    wrongPortalMsg2: 'est destine aux agences partenaires qui revendent AiLys. Pour gerer votre abonnement, visitez le tableau de bord client principal.',
    partnerOverview: 'Apercu partenaire',
    activeClients: 'Clients actifs',
    activeClientsDesc: 'Attribues a votre organisation',
    ytdCommissions: 'Commissions cumul annuel',
    ytdCommissionsDesc: 'Total admissible T4A (CAD)',
    tier: 'Niveau',
    tierDesc: 'Niveau de qualification',
    certification: 'Certification',
    quickLinks: 'Liens rapides',
    linkClients: 'Vos clients attribues',
    linkCommissions: 'Releves de commissions',
    linkSettings: 'Parametres du compte',
    linkHelp: 'Centre d\'aide',
    staffOverview: 'Apercu employe AiLys',
    staffOverviewMsg: 'Vue interne du canal partenaire. Liste pilote + evenements d\'attribution recents dans un prochain lot. Acces admin complet a',
    adminOverview: 'Apercu admin AiLys',
    adminOverviewMsg: 'L\'acces admin complet aux donnees du canal partenaire se trouve a',
    tierPending: 'En attente',
    tierStarter: 'Starter',
    tierSilver: 'Silver',
    tierGold: 'Gold',
    tierElite: 'Elite',
    certInTraining: 'En formation',
    certActive: 'Actif',
    certExpired: 'Expire',
    certRevoked: 'Revoque',
    certRenewRequired: 'Renouvellement requis',
    certContactSupport: 'Contacter le support AiLys',
    certCompleteTraining: 'Completez la formation pour obtenir la certification',
    certRecertifyDays: 'Recertification dans {days} jours',
    certRenewalOverdue: 'Renouvellement en retard',
    certRecertifyBefore: 'Recertifier avant 365 jours',
  },

  clients: {
    title: 'Vos clients',
    subtitle: 'Entreprises que vous avez fermes pour AiLys. Recherchez par ID locataire ou niveau. Un etat vide signifie aucune attribution; la premiere fermeture s\'enregistre a partir du guide d\'integration fondateur Etape 10.',
    searchPlaceholder: 'Rechercher par ID locataire ou niveau...',
    errorMsg: 'Impossible de charger les clients ({error}). Reessayez ou contactez partners@ailysagency.ca.',
    emptyTitle: 'Aucun client attribue',
    emptyDesc: 'Aucun client attribue pour l\'instant. Votre premiere fermeture apparaitra ici une fois que le fondateur AiLys l\'enregistrera apres votre signalement.',
    colClosed: 'Ferme',
    colTenant: 'Locataire',
    colTier: 'Niveau',
    colMrr: 'RMM',
    colStatus: 'Statut',
    colCsat: 'CSAT',
    colLoi25: 'Loi 25',
    statusActive: 'ACTIF',
    statusStaff: 'personnel',
    loi25Missing: 'MANQUANT',
    loi25OnFile: 'au dossier',
  },

  clientDetail: {
    backLink: 'Retour aux clients',
    notFoundTitle: 'Non trouve',
    notFoundMsg: 'Aucun client avec cet ID n\'est attribue a votre organisation. Soit l\'ID est incorrect, soit ce client appartient a un autre partenaire. Si vous croyez qu\'il s\'agit d\'une erreur, contactez partners@ailysagency.ca.',
    title: 'Detail du client',
    closedOn: 'Ferme',
    tierAtClose: 'Niveau a la fermeture',
    initialMrr: 'RMM initial',
    currentMrr: 'RMM actuel',
    status: 'Statut',
    csat: 'CSAT',
    csatNone: 'Aucun sondage',
    loi25Legacy: 'Consentement Loi 25 (preuve historique)',
    loi25Missing: 'MANQUANT - demandez l\'Annexe B signee au client',
    consentLedgerTitle: 'Registre de consentement Loi 25',
    consentLedgerDesc: 'Consentement multi-niveaux selon ADR-0019. Un consentement actif de type partner-views est requis avant que les donnees de ce client soient visibles pour votre agence. Retirez a tout moment; piste d\'audit preservee.',
    consentLoading: 'Chargement du registre de consentement...',
    consentActive: 'Consentement ACTIF ({scopes})',
    consentNone: 'AUCUN consentement actif - capturez ci-dessous avant d\'acceder aux donnees',
    consentCapture: 'Capturer le consentement Annexe B',
    consentHistory: 'Historique ({count})',
    consentWithdrawn: 'retire {date}',
    consentWithdraw: 'Retirer',
    consentCaptured: 'Consentement capture. Enregistrement Annexe B stocke.',
    consentWithdrawnSuccess: 'Consentement retire. Piste d\'audit preservee.',
  },

  commissions: {
    title: 'Commissions',
    subtitle: 'Total cumulatif annuel admissible T4A + liste de releves mensuels. Les releves sont payes le 1er du mois suivant la fermeture de la periode (MVP manuel Niveau 1 via Virement Interac; depot direct Stripe Connect Express dans la Phase 6.2).',
    errorMsg: 'Impossible de charger les commissions ({error}). Reessayez ou contactez partners@ailysagency.ca.',
    ytdTitle: 'Total cumulatif annuel admissible T4A (CAD)',
    ytdDesc: 'Somme des commissions nettes payees en {year} marquees admissibles T4A. Si ce total atteint 500 $ CAD en fin d\'annee, AiLys emet un feuillet T4A en fevrier.',
    colPeriod: 'Periode',
    colAttributions: 'Attributions',
    colGross: 'Brut',
    colAdjust: 'Ajust.',
    colNet: 'Net',
    colStatus: 'Statut',
    colPaid: 'Paye',
    colT4a: 'T4A',
    periodRange: '{start} a {end}',
    noPaid: '-',
  },

  team: {
    title: 'Equipe',
    lockedTitle: 'Niveau Silver requis',
    lockedDesc: 'L\'embauche de sous-agents se deverrouille au Niveau 2 Silver. Les partenaires Niveau 1 Starter operent en solo. Atteignez 30 fermetures qualifiantes, 80% de retention et 400 $ de RMM moyen pour vous qualifier.',
    backLink: 'Retour au tableau de bord',
    subtitle: 'Gerez vos sous-agents et attributions de clients',
    inviteBtn: 'Inviter un agent',
    inviteTitle: 'Inviter un sous-agent',
    inviteSuccess: 'Invitation creee. Partagez ce lien avec l\'agent:',
    fieldName: 'Nom',
    fieldNamePlaceholder: 'Nom de l\'agent',
    fieldEmail: 'Courriel',
    fieldEmailPlaceholder: 'agent@example.com',
    fieldClassification: 'Classification',
    classOther: 'Autre',
    classW2: 'Employe W-2',
    classT4a: 'Sous-traitant T4A',
    fieldCommission: 'Taux de commission (%)',
    sendInvite: 'Envoyer l\'invitation',
    loadingTeam: 'Chargement de l\'equipe...',
    emptyTitle: 'Aucun agent',
    emptyDesc: 'Cliquez sur "Inviter un agent" pour ajouter votre premier sous-agent.',
    activeAgents: 'Agents actifs ({count})',
    joined: 'Rejoint le {date}',
    commission: 'Commission',
    assignedClients: 'Clients',
    shadowCopilotSolo: 'Observation / Copilote / Solo',
    terminate: 'Resilier',
    terminatedSection: 'Resilies ({count})',
    terminatedOn: 'Resilie le {date}',
    inviteFailed: 'Impossible d\'envoyer l\'invitation. Reessayez.',
    terminateFailed: 'Impossible de resilier l\'agent. Reessayez.',
    commissionUpdateFailed: 'Impossible de mettre a jour la commission. Reessayez.',
  },

  training: {
    title: 'AiLys University',
    subtitle: 'Formation',
    backLink: 'Retour au tableau de bord',
    tabCourses: 'Cours ({count})',
    tabCertifications: 'Certifications ({count})',
    noCourses: 'Aucun cours disponible pour l\'instant. Revenez bientot.',
    noCerts: 'Aucune certification. Completez un cours pour obtenir votre premiere certification.',
    hours: '~{hours}h',
    modules: '{count} modules',
    progress: '{pct}%',
    moduleDone: '{done}/{total} completes',
    duration: '{duration}min',
    optional: 'optionnel',
    attempts: '{count} tentative(s)',
    issued: 'Emis le: {date}',
    expires: 'Expire le: {date}',
    daysRemaining: '{days}j restants',
    categoryProduct: 'produit',
    categorySales: 'ventes',
    categoryTechnical: 'technique',
    categoryCompliance: 'conformite',
    loadingTraining: 'Chargement des donnees de formation...',
  },

  whiteLabel: {
    title: 'Marque blanche',
    lockedDesc: 'La marque blanche est disponible pour les partenaires de niveau Gold et Elite. Vos documents destines aux clients (rapports, courriels, pages d\'atterrissage) afficheront votre image de marque au lieu de celle d\'AiLys.',
    lockedAction: 'Contactez votre strategiste ou atteignez le niveau Gold pour deverrouiller cette fonctionnalite.',
    subtitle: 'Personnalisez l\'apparence de votre marque sur les documents destines aux clients.',
    fieldLogoUrl: 'URL du logo (https uniquement)',
    fieldLogoPlaceholder: 'https://votre-domaine.com/logo.png',
    fieldPrimaryColor: 'Couleur principale',
    fieldSecondaryColor: 'Couleur secondaire',
    fieldCompanyName: 'Nom de l\'entreprise (affiche sur les rapports)',
    fieldCompanyPlaceholder: 'Votre Agence',
    fieldFooterText: 'Texte de pied de page (affiche en bas des rapports)',
    fieldFooterPlaceholder: 'Propulse par Votre Agence',
    fieldEmailFromName: 'Nom d\'expediteur courriel',
    fieldEmailFromPlaceholder: 'Votre Agence',
    previewTitle: 'Apercu',
    previewFooter: 'Le texte de pied de page apparaitra ici sur les rapports clients.',
    saveBtn: 'Enregistrer la marque',
    saved: 'Marque enregistree.',
  },

  settings: {
    title: 'Parametres',
    errorMsg: 'Impossible de charger les parametres ({error}).',
    orgSection: 'Organisation',
    orgTier: 'Niveau',
    orgCert: 'Cert',
    orgCertExpires: 'Expiration cert',
    legalEntity: 'Entite juridique (NE ou NAS)',
    legalEntityReadonly: 'Lecture seule. Pour modifier votre entite juridique (ex. changement de REQ ou reemission de NE), envoyez un courriel a partners@ailysagency.ca avec la documentation. Le personnel AiLys met a jour le dossier apres verification.',
    addressSection: 'Adresse postale (livraison T4A)',
    addressDesc: 'Utilisee pour la livraison postale du T4A si vous n\'avez pas opte pour la livraison par courriel. Doit correspondre a votre adresse legale enregistree.',
    fieldStreet: 'Adresse',
    fieldApt: 'App. / Bureau / Unite (optionnel)',
    fieldCity: 'Ville',
    fieldProvince: 'Province',
    fieldPostal: 'Code postal',
    postalPlaceholder: 'A1A 1A1',
    saveAddress: 'Enregistrer l\'adresse',
    twoFaSection: 'Authentification a deux facteurs',
    twoFaDesc: 'Obligatoire pour partner_owner. Gerez votre authentificateur TOTP ou codes de recuperation via le fournisseur d\'identite AiLys:',
    twoFaLink: 'Gerer les parametres 2FA',
    complianceSection: 'Statut de conformite',
    dpaSigned: 'DPA signe:',
    msaSigned: 'MSA signe:',
    notSigned: 'NON SIGNE',
  },

  profile: {
    title: 'Profil public',
    subtitle: 'Personnalisez votre page de destination co-marquee a ailysagency.ca/partners/votre-slug',
    loadingProfile: 'Chargement du profil...',
    fieldDisplayName: 'Nom d\'affichage',
    fieldDisplayNamePlaceholder: 'Votre nom tel qu\'affiche publiquement',
    fieldHeadline: 'Titre',
    fieldHeadlinePlaceholder: 'ex. Specialiste SEO local pour restaurants',
    fieldBio: 'Biographie',
    fieldBioPlaceholder: 'Parlez de vous aux clients potentiels...',
    fieldPhotoUrl: 'URL de la photo',
    fieldPhotoUrlPlaceholder: 'https://...',
    fieldCity: 'Ville',
    fieldCityPlaceholder: 'Montreal',
    fieldCountry: 'Pays',
    fieldCountryPlaceholder: 'CA',
    fieldSpecialties: 'Specialites (separees par des virgules)',
    fieldSpecialtiesPlaceholder: 'restaurants, hotels, cliniques dentaires',
    fieldSlug: 'Identifiant public',
    slugPrefix: 'ailysagency.ca/partners/',
    slugPlaceholder: 'votre-nom',
    fieldContactEmail: 'Courriel de contact',
    fieldContactEmailPlaceholder: 'vous@example.com',
    fieldLinkedIn: 'URL LinkedIn',
    fieldLinkedInPlaceholder: 'https://linkedin.com/in/votre-profil',
    enableLanding: 'Activer la page de destination publique',
    enableLandingDesc: 'Lorsqu\'active, votre profil est visible a ailysagency.ca/partners/{slug}',
    saveProfile: 'Enregistrer le profil',
    linksSection: 'Vos liens',
    linkLandingPage: 'Page de destination:',
    linkSigImage: 'Signature courriel:',
    copySigUrl: 'Copier l\'URL de la signature',
  },

  notifications: {
    title: 'Notifications',
    markAllRead: 'Tout marquer comme lu',
    empty: 'Aucune notification pour le moment.',
  },

  session: {
    expiringTitle: 'Session expirante',
    expiringMsg: 'Votre session expire dans {seconds}s.',
    extend: 'Prolonger la session',
    expired: 'Session expiree. Veuillez vous reconnecter.',
  },
} as const;
